import { Id } from './id'
class Weather {
  temp: number | undefined = undefined
  icon: string | undefined = undefined
  feelsLike: number | undefined = undefined
  tempMin: number | undefined = undefined
  tempMax: number | undefined = undefined
  pressure: number | undefined = undefined
  humidity: number | undefined = undefined
  windSpeed: number | undefined = undefined
  windDirection: number | undefined = undefined
  description: string | undefined = undefined
  visibility: number | undefined = undefined
  cloudsAll: number | undefined = undefined
}

class Sys {
  type: number | undefined = undefined
  id: number | undefined = undefined
  country: string | undefined = undefined
  sunrise: number | undefined = undefined
  sunset: number | undefined = undefined
}

class Stats {
  start: string | undefined = undefined
  end: string | undefined = undefined
  delay: number | undefined = undefined
  count: number | undefined = undefined
  timeline: Array<string | string | number | number> | undefined = undefined
}

class Coordinates {
  lat: number | undefined = undefined
  lng: number | undefined = undefined
  public asArray() {
    return [this.lat, this.lng]
  }
}
export class Location {
  public url: string | undefined
  public cod: number | undefined
  public friendlyName: string | undefined
  public country: string | undefined
  public timezone: number | undefined
  public coordinates: Coordinates = new Coordinates()

  public weather: Weather = new Weather()

  public sys: Sys = new Sys()

  public name: string | undefined
  public tags: string[] | undefined

  public stats: Stats = new Stats()

  constructor(public id: Id) {}
  /*
   * Return a formated string with the local time on the location
   */
  get timeInLocation(): string {
    if (!this.timezone) {
      return 'N/A'
    }
    const timezone = Number(this.timezone) * 1000
    const utcTime: number = new Date().getTime()
    /* calculates the time in local location */
    const sum = new Date(timezone + utcTime)
    let hour = '' + new Date(sum).getUTCHours()
    let minute = '' + new Date(sum).getUTCMinutes()
    /* add 0 before hour and minute if needed */
    hour.length == 1 ? (hour = '0' + hour) : (hour = hour)
    minute.length == 1 ? (minute = '0' + minute) : (minute = minute)
    const output = `${hour}:${minute}`
    return output
  }
}
